import { Paper } from '@mui/material'
import type { ReactNode } from 'react'

type DevicePaperProps = {
  children: ReactNode
}

export const DevicePaper: React.FC<DevicePaperProps> = props => {
  return (
    <Paper
      sx={{
        p: '32px',
        mt: 1.5,
        maxWidth: '100%',
        overflowX: 'auto',
        width: '1418px',
        '@media (max-width: 1756px)': {
          width: 'auto',
          marginRight: '10px',
        },
        height: 'calc(100vh - 330px)',
        boxShadow: '0px 2px 2px #00000014',
        borderRadius: '10px',
      }}
      elevation={2}
    >
      {props.children}
    </Paper>
  )
}
